<mat-form-field appearance="outline" class="inputs">
  <mat-label>Preencher Número do Processo padrão CNJ</mat-label>
  <input
    maxlength="25"
    matInput
    mask="0000000-00.0000.0.00.0000"
    placeholder="0000000-00.0000.0.00.0000"
    [formControl]="control"
    [attr.data-cy]="'input-numero-processo-' + tipoOrdem"
    (blur)="validarNumeroProcesso()"
  />
  <mat-hint align="end">{{ control.value.length }} / 20</mat-hint>
  <mat-error *ngIf="control.hasError('valueEmptyError')">
    Número CNJ é <strong>obrigatório</strong>
  </mat-error>
  <mat-error *ngIf="control.hasError('valueFormatError')">
    Número CNJ deve possuir 20 caracteres. Atual {{ control.value.length }} / 20.
  </mat-error>
  <mat-error *ngIf="control.hasError('valueFormatError')">
    Número CNJ deve ser um número com exatamente 20 dígitos.
  </mat-error>
  <mat-error *ngIf="control.hasError('valueInvalidError')">
    Número CNJ incompatível com a UF do usuário. Verifique os dígitos 14, 15 e 16.
  </mat-error>
  <mat-error *ngIf="control.hasError('aguardandoValidacao')">
    Aguardando validação do número do processo...
  </mat-error>
</mat-form-field>
